// src/AdminContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [adminToken, setAdminToken] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    // Rehydrate admin and adminToken from localStorage
    const savedAdmin = localStorage.getItem('admin');
    const savedAdminToken = localStorage.getItem('token');

    if (savedAdmin && savedAdminToken) {
      setAdmin(savedAdmin);
      setAdminToken(savedAdminToken);
    }
    setLoading(false); // Set loading to false after attempting rehydration
  }, []);

  const login = (adminData, authToken) => {
    setAdmin(adminData);
    setAdminToken(authToken);
    localStorage.setItem('admin', adminData);
    localStorage.setItem('token', authToken);
  };

  const logout = () => {
    setAdmin(null);
    setAdminToken(null);
    localStorage.removeItem('admin');
    localStorage.removeItem('token');
  };

  if (loading) {
    return <div>Loading...</div>; // Show a loading spinner or message while rehydrating
  }

  return (
    <AdminContext.Provider value={{ admin, adminToken, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
